export default {
    navigation: {
        app: 'app',
        home: 'home',
        contact: 'contact',
        login: 'login',
        register: 'register',
        addTab: 'addTab',
        askTab: 'askTab',
        accountSettings : 'accountSettings',
        myTabs : 'myTabs',
        terms : 'terms',
        tab : 'tab',
        artist : 'artist',
        artists : 'artists',
        notFound : 'notFound',
    },
    keyCodes: {
        ESC: 27,
        ENTER: 13
    },
    letters : 
        ['nl','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
};


// WEBPACK FOOTER //
// ./src/util/const.js